import { useSelector, useDispatch } from "react-redux";
import { setIsOpen, setUserInfo,setAvatar } from "@/store/modules/user";
import { Button, Modal, Form, Input, Checkbox, Flex, message } from 'antd';
import styles from './index.module.scss';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { login, userDetail, getEmailCode, checkEmailCode, changePassWord } from "@/apis/user";
// import {getCollectionsByUser} from '@/apis/discover';
import { encrypt } from "@/utils/jsencrypt";
import intl from "react-intl-universal";
import { useState, useEffect } from "react";
const { Search } = Input;
let timer = null
const LoginDialog = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { isOpen } = useSelector(state => state.user)
	const [isShowFind, setIsShowFind] = useState(false)
	let [count, setCount] = useState(0);
	const [captchaUuid, setCaptchaUuid] = useState('')
	const [formForget] = Form.useForm();

	useEffect(() => {
		return () => {
			timer && clearInterval(timer)
		}
	}, [])

	const handleCancel = () => {
		dispatch(setIsOpen(false))
	};

	const onFinish = (values) => {
		const password = encrypt(values.password)
		login({
			username: values.username,
			password: password,
		}).then(res => {
			dispatch(setIsOpen(false))
			dispatch(setUserInfo({
				token: res.data.token,
				refreshToken: res.data.refreshToken,
			}))
			userDetail().then(result => { 
				dispatch(setUserInfo({
					email: result.data.email,
					username: result.data.username,
					nickname:result.data.nickname,
					token: res.data.token,
					refreshToken: res.data.refreshToken,
					roleId: result.data?.role?.roleId,
					password: password,
					uuid:result.data.uuid
				}))
				dispatch(setAvatar(result.data?.avatar?.filePath))
			})
			// getCollectionsByUser().then(result=>{
			// 	dispatch(setCollections(result.data))
			// })
			// 判断是否需要指定路径跳转
			const link = localStorage.getItem("link")
			if (link) {
				window.scrollTo(0, 0);
				localStorage.setItem("link", "")
				setTimeout(() => {
					navigate(link)
				}, 100)
			}
		}).catch(err => { })
	};

	const goRegister = () => {
		dispatch(setIsOpen(false))
		navigate("/register")
	}

	// 点击忘记密码
	const forget = () => {
		formForget.setFieldsValue({
			emailCode: "",
			newPassword: "",
			email: ""
		})
		setCount(0)
		dispatch(setIsOpen(false))
		setIsShowFind(true)
	}

	// 关闭忘记密码弹窗
	const cancelForget = () => {
		setIsShowFind(false)
		dispatch(setIsOpen(true))
	}

	const onFinishForget = (values) => {
		// 校验邮箱验证码
		checkEmailCode({
			captchaName: values.email,
			captchaUuid: captchaUuid,
			captchaValue: values.emailCode
		}).then(res => {
			// 修改密码
			changePassWord({
				captchaRecord: res.data,
				email: values.email,
				newPassword: encrypt(values.newPassword)
			}).then(res => {
				message.open({
					type: "success",
					content: intl.get("User.Password changed successfully"),
					duration: 10,
				})
				timer && clearInterval(timer)
				cancelForget()
			}).catch(err => { })
		}).catch(err => { })
	}

	// 获取验证码
	const getCode = (val) => {
		timer && clearInterval(timer)
		formForget.setFieldValue(
			"emailCode", ""
		)
		if (val) {
			getEmailCode({
				email: val,
				type: 2
			}).then(res => {
				message.open({
					type: "success",
					content: intl.get("Register.emailDes"),
					duration: 10,
				})
				setCaptchaUuid(res.data)
				// 倒计时
				let num = 120
				timer = setInterval(() => {
					setCount(num - 1)
					if (num === 0) {
						clearInterval(timer)
					}
					num = num - 1
				}, 1000)
			}).catch(err => { })
		}
	}

	return (
		<div>
			<Modal title={intl.get("User.Sign in to your account")} className={styles.modalTitle} open={isOpen} footer={null} onCancel={handleCancel}>
				<Form
					layout="vertical"
					onFinish={onFinish}
					autoComplete="off"
					className={styles.formBox}
					size="large"
				>
					<Form.Item
						label={intl.get("User.Username")}
						name="username"

						rules={[
							{
								required: true,
								message: intl.get("User.Please input your username"),
							},
						]}
					>
						<Input prefix={<UserOutlined />} />
					</Form.Item>

					<Form.Item
						label={intl.get("User.Password")}
						name="password"
						rules={[
							{
								required: true,
								message: intl.get("User.Please input your password"),
							},
						]}
					>
						<Input.Password prefix={<LockOutlined />} />
					</Form.Item>

					<Form.Item>
						<Flex justify="space-between" align="center">
							<Form.Item name="remember" valuePropName="checked" noStyle>
								<Checkbox>{intl.get("User.Remember me")}</Checkbox>
							</Form.Item>
							<div>
								<a href="#" onClick={forget}>{intl.get("User.Forgot password")}</a>
								<span className={styles.spanBox}>{intl.get("User.or")}</span>
								<a href="#" onClick={goRegister}>{intl.get("User.Register now")}</a>
							</div>
						</Flex>
					</Form.Item>

					<Form.Item>
						<Button block type="primary" htmlType="submit">
							{intl.get("User.Log in")}
						</Button>
					</Form.Item>
				</Form>
			</Modal>

			<Modal title={intl.get("User.Update password")} open={isShowFind} footer={null} onCancel={cancelForget}>
				<Form
					layout="vertical"
					onFinish={onFinishForget}
					autoComplete="off"
					form={formForget}
					className={styles.formBox}
					size="large"
				>
					<Form.Item
						label={intl.get("Email")}
						name="email"
						rules={[
							{
								required: true,
								message: intl.get("User.emailMsg"),
							}, {
								type: 'email',
								message: intl.get("Email must be formatted correctly")
							}
						]}
					>
						<Search
							enterButton={count > 0 ? intl.get("User.Get code") + count : intl.get("User.Get code")}
							size="large"
							disabled={count > 0}
							onSearch={getCode}
						/>
					</Form.Item>

					<Form.Item
						label={intl.get("User.New password")}
						name="newPassword"
						rules={[
							{
								required: true,
								message: intl.get("User.Please enter your new password"),
							},
						]}
					>
						<Input.Password />
					</Form.Item>

					<Form.Item
						label={intl.get("Register.Email verification code")}
						name="emailCode"
						rules={[
							{
								required: true,
								message: intl.get("Register.Please enter the six digit code received by email"),
							},
						]}
					>
						<Input.OTP />
					</Form.Item>
					<Form.Item>
						<Button block type="primary" htmlType="submit">
							{intl.get("Share.Submit")}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>

	)
}
export default LoginDialog
